import { gql } from "@apollo/client";

export const GET_MASTER_DATA_RETAILER_MATCH_RULES = gql`
  query MasterDataRetailerMatchRules(
    $params: MasterDataRetailerMatchRulesParamsInput!
  ) {
    masterDataRetailerMatchRules(params: $params) {
      total
      page
      limit
      items {
        ruleId
        retailerId
        matchPattern
        matchPriority
        sourceColumn
        retailerName
      }
    }
  }
`;
